module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("Maps")]), _vm._v(" "), _c('p', {
    staticClass: "map-para"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter01#img35"
    }
  }, [_vm._v("The World of the Bible")])]), _vm._v(" "), _c('p', {
    staticClass: "map-para"
  }, [_c('span', {
    attrs: {
      "href": "#/015a_Chapter04#img155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roman Empire 117 CE")])]), _vm._v(" "), _c('p', {
    staticClass: "map-para"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#img224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Border Regions of the Roman and Persian Empires")])]), _vm._v(" "), _c('p', {
    staticClass: "map-para"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter07#img266",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Early Medieval Europe")])]), _vm._v(" "), _c('p', {
    staticClass: "map-para"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#img330",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Persian Eastern Provinces")])]), _vm._v(" "), _c('p', {
    staticClass: "map-para"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#img334",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Silk Road and Connected Trading Routes")])]), _vm._v(" "), _c('p', {
    staticClass: "map-para"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter09#img366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbasid Empire")])]), _vm._v(" "), _c('p', {
    staticClass: "map-para"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter09#img380",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mongol Empire")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b112bd6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Maps.vue
// module id = 75
// module chunks = 0